import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_DEVICES_CONNECTORS } from "../../../API/UserApi";

import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const deleteChargingDeviceConnectorsAPI: any = createAsyncThunk(
  "deleteChargingDeviceConnectors",
  async (rowId: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.delete(
        CHARGING_DEVICES_CONNECTORS + "/" + rowId,
        {
          headers: commonHead,
        }
      );
      return { chargingDeviceConnectorDeleted: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
